import { render, staticRenderFns } from "./personRealName.vue?vue&type=template&id=08e78afe&"
import script from "./personRealName.vue?vue&type=script&lang=js&"
export * from "./personRealName.vue?vue&type=script&lang=js&"
import style0 from "./personRealName.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports